import { render, staticRenderFns } from "./RewardConfirmation.vue?vue&type=template&id=6cb12b88"
import script from "./RewardConfirmation.vue?vue&type=script&lang=js"
export * from "./RewardConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports